import React, { useCallback } from "react";
import moment from "moment";
import styles from "./CountDown.module.scss";
const CountDown = () => {
  const countDownTimer = useCallback((date) => {
    let _vDate = moment(date);
    let _second = 1000;
    let _minute = _second * 60;
    let _hour = _minute * 60;
    let _day = _hour * 24;
    let timer;

    function showRemaining() {
      try {
        let now = moment();
        let distDt = _vDate - now;

        if (distDt < 0) {
          clearInterval(timer);
          let HapDate = `00 : 00 : 00 : 00`;
          document.getElementById("timer").innerHTML = HapDate;
          return;
        }
        let days =
          String(Math.floor(distDt / _day)).length === 2
            ? Math.floor(distDt / _day)
            : "0" + String(Math.floor(distDt / _day));
        let hours =
          String(Math.floor((distDt % _day) / _hour)).length === 2
            ? Math.floor((distDt % _day) / _hour)
            : "0" + String(Math.floor((distDt % _day) / _hour));
        let minutes =
          String(Math.floor((distDt % _hour) / _minute)).length === 2
            ? Math.floor((distDt % _hour) / _minute)
            : "0" + String(Math.floor((distDt % _hour) / _minute));
        let seconds =
          String(Math.floor((distDt % _minute) / _second)).length === 2
            ? Math.floor((distDt % _minute) / _second)
            : "0" + String(Math.floor((distDt % _minute) / _second));

        let HapDate = `
            <div><span>${
              typeof days === "number" ? parseInt(days) : days
            }</span>
            <span>Days</span>
            </div>  <div><span>${
              typeof hours === "number" ? parseInt(hours) : hours
            }</span><span>Hours</span></div>  <div><span>${
          typeof minute === "number" ? parseInt(minutes) : minutes
        }</span><span>Minutes</span></div> <div><span>${
          typeof seconds === "number" ? parseInt(seconds) : seconds
        }</span><span>Seconds</span></div>`;

        document.getElementById(styles.timer).innerHTML = HapDate;
      } catch (e) {
        console.log(e);
      }
    }
    timer = setInterval(showRemaining, 1000);
  }, []);
  return (
    <div className={styles.container}>
      {moment().isBefore("2023-05-29 09:00:00") && (
        <div className={styles.count_down_box}>
          <span className={styles.count_down_text}>
            <span>Countdown to</span>
            <span>Summer Splash</span>
          </span>
          <span id={styles.timer}>{countDownTimer("2023-05-29 09:00:00")}</span>
        </div>
      )}
      {moment().isAfter("2023-05-29 09:00:00") && (
        <div className={styles.count_down_change_box}>
          <span className={styles.count_down_change_text}>
            Submissions Closing in...
          </span>
          <span id={styles.timer}>{countDownTimer("2023-07-08 09:00:00")}</span>
        </div>
      )}
    </div>
  );
};

export default CountDown;
